import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { environment } from '../../../../../../../../environments/environment';
import { AnimationItem } from 'lottie-web';

@Component({
  selector: 'app-complete-animation',
  standalone: true,
  imports: [CommonModule, LottieComponent],
  templateUrl: './complete-animation.component.html',
  styleUrl: './complete-animation.component.scss',
})
export class CompleteAnimationComponent {
  // Values to be displayed:
  // Stream the time estimation -> and Add a click on
  options: AnimationOptions = {
    path: `${environment.basePath}assets/lottie/complete_animation.json`,
    loop: false, // This ensures the animation does not repeat
  };
}
